import React, { useEffect } from "react";
import Toggle from "./Toggle";
import { useContext } from "react";
import DataContext from "Context/DataContext";
import { Link } from "gatsby";

const ManageCookie = () => {
  const {
    toggleStates,
    setToggleStates,
    setShowCookie,
    cookiePreference,
    setCookiePreference,
  } = useContext(DataContext);

  const acceptAllCookie = () => {
    setToggleStates({
      analyticsCookies: true,
      functionalCookies: true,
      advertisingCookies: true,
    });
  };
  const rejectAllCookie = () => {
    setToggleStates({
      analyticsCookies: false,
      functionalCookies: false,
      advertisingCookies: false,
    });
  };

  const toggleSwitch = (name) => {
    setToggleStates((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  useEffect(() => {
    toggleStates.analyticsCookies
      ? localStorage.setItem("analyticsCookies", "true")
      : localStorage.setItem("analyticsCookies", "false");
    toggleStates.functionalCookies
      ? localStorage.setItem("functionalCookies", "true")
      : localStorage.setItem("functionalCookies", "false");
    toggleStates.advertisingCookies
      ? localStorage.setItem("advertisingCookies", "true")
      : localStorage.setItem("advertisingCookies", "false");
  }, [toggleStates]);

  return (
    <section className="z-50  left-0 right-0 mx-auto lg:h-screen  h-max fixed lg:top-[180px] top-[110px] ">
      <div
        style={{ boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)" }}
        className="manageCookie  md:h-max h-[544px] md:overflow-y-hidden overflow-y-scroll  w-full mx-auto md:max-w-[600px] max-w-[350px] bg-[#fff] 
  rounded-lg  ease-in-out duration-300    
    "
      >
        <div className="relative bg-white  rounded-2xl p-6 dark:bg-gray-700">
          <div className="flex items-start justify-between   rounded-t ">
            <div className="flex flex-col">
              <div className="flex md:justify-between gap-4">
                <p className="text-lg text-[#131313] font-bold font-primary ">
                  Manage Your Cookie Preferences
                </p>
                <button
                  onClick={() => {
                    rejectAllCookie();
                  }}
                  className="underline underline-offset-2 font-normal  text-[#808080] font-opensans text-sm  hover:text-[#FF7B16]"
                >
                  Decline All
                </button>
              </div>
              <p className="text-sm text-[#131313] pt-3 font-opensans">
                At Tomedes, we prioritize your privacy and transparency. We use
                third-party cookies to enhance your experience and provide
                tailored services. You can manage your preferences below:
              </p>
            </div>
            {/* <button
              onClick={() => {
                setCookiePreference(false);
              }}
              type="button"
              className="text-gray-400 bg-transparent h text-sm w-8 h-8 ml-auto inline-flex justify-center items-center "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
              >
                <rect width="50" height="50" rx="14" fill="white" />
                <path
                  d="M37.5 12.5L12.5 37.5"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5 12.5L37.5 37.5"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button> */}
          </div>

          <div className="cookiePrefrence  mt-5">
            <div className="flex flex-col gap-3">
              <label className=" px-4 py-2 relative flex justify-between items-center border border-[#D7D7D7] rounded-[6px]">
                <div className="flex gap-2 items-center ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                  >
                    <path
                      d="M15 8.40181V8.99981C14.9992 10.4015 14.5453 11.7654 13.7061 12.888C12.8668 14.0106 11.6871 14.8319 10.343 15.2294C8.99883 15.6268 7.56222 15.5791 6.24741 15.0933C4.93259 14.6075 3.81003 13.7098 3.04712 12.5339C2.28422 11.358 1.92186 9.96706 2.01409 8.56842C2.10632 7.16978 2.64818 5.83843 3.55888 4.77291C4.46958 3.7074 5.70031 2.96481 7.06752 2.65591C8.43474 2.34701 9.86517 2.48833 11.1455 3.05881"
                      stroke="#666666"
                      stroke-width="1.41667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.9998 3.80078L8.4998 10.3073L6.5498 8.35728"
                      stroke="#666666"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span className="text-sm text-[#131313]  font-semibold font-primary">
                    Essential
                  </span>
                  <span className="text-[12px] text-[#929292] font-primary  ">
                    *always active
                  </span>
                </div>

                <Toggle
                  enabled={true}
                  toggle={() => toggleSwitch("essentialCookies")}
                  type="essentialCookies"
                />
              </label>

              <label className=" px-4 py-2 relative flex justify-between items-center border border-[#D7D7D7] rounded-[6px]">
                <div className="flex gap-2 items-center ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                  >
                    <mask id="path-1-inside-1_8173_10676" fill="white">
                      <path d="M15.0239 11.7548C14.5732 12.8204 13.8684 13.7595 12.971 14.4898C12.0737 15.2202 11.011 15.7196 9.87605 15.9444C8.74102 16.1692 7.56823 16.1125 6.46023 15.7794C5.35219 15.4462 4.34265 14.8466 3.51984 14.0332C2.69704 13.2197 2.08603 12.2171 1.74024 11.1129C1.39444 10.0088 1.3244 8.83677 1.53621 7.69926C1.74803 6.56179 2.23526 5.49352 2.95532 4.58784C3.67538 3.68217 4.60633 2.96667 5.66679 2.50391" />
                    </mask>
                    <path
                      d="M9.87605 15.9444L10.148 17.3177L10.1481 17.3177L9.87605 15.9444ZM6.46023 15.7794L6.05706 17.1201L6.05713 17.1201L6.46023 15.7794ZM3.51984 14.0332L2.53556 15.0288L2.53557 15.0288L3.51984 14.0332ZM1.53621 7.69926L0.159871 7.44296L0.159868 7.44298L1.53621 7.69926ZM13.7344 11.2095C13.3728 12.0646 12.8073 12.818 12.0873 13.404L13.8548 15.5757C14.9295 14.701 15.7736 13.5763 16.3133 12.3L13.7344 11.2095ZM12.0873 13.404C11.3673 13.99 10.5147 14.3907 9.60401 14.5711L10.1481 17.3177C11.5073 17.0485 12.78 16.4504 13.8548 15.5757L12.0873 13.404ZM9.60411 14.5711C8.69336 14.7514 7.75234 14.7059 6.86332 14.4386L6.05713 17.1201C7.38412 17.519 8.78867 17.5869 10.148 17.3177L9.60411 14.5711ZM6.86339 14.4387C5.97433 14.1713 5.16431 13.6903 4.50411 13.0376L2.53557 15.0288C3.52099 16.003 4.73005 16.721 6.05706 17.1201L6.86339 14.4387ZM4.50412 13.0376C3.84395 12.3849 3.3537 11.5804 3.07625 10.6945L0.404225 11.5313C0.818362 12.8537 1.55013 14.0545 2.53556 15.0288L4.50412 13.0376ZM3.07625 10.6945C2.79881 9.80861 2.7426 8.86825 2.91255 7.95555L0.159868 7.44298C-0.0938054 8.8053 -0.00991654 10.209 0.404225 11.5313L3.07625 10.6945ZM2.91255 7.95556C3.0825 7.04291 3.47344 6.18578 4.05118 5.45911L1.85946 3.71658C0.997091 4.80126 0.413557 6.08067 0.159871 7.44296L2.91255 7.95556ZM4.05118 5.45911C4.62892 4.73244 5.37587 4.15836 6.22674 3.78705L5.10685 1.22076C3.83679 1.77499 2.72184 2.6319 1.85946 3.71658L4.05118 5.45911Z"
                      fill="#666666"
                      mask="url(#path-1-inside-1_8173_10676)"
                    />
                    <path
                      d="M14.8448 8.3013H9.2V2.65647C9.79798 2.72244 10.3848 2.87275 10.9428 3.10386L10.9428 3.10387C11.7173 3.42466 12.421 3.89486 13.0137 4.4876C13.6064 5.08032 14.0766 5.784 14.3974 6.55849L14.8448 8.3013ZM14.8448 8.3013C14.7789 7.70335 14.6285 7.11651 14.3974 6.55853L14.8448 8.3013Z"
                      stroke="#666666"
                      stroke-width="1.4"
                    />
                  </svg>
                  <span class="text-sm text-[#131313]  font-semibold font-primary">
                    Analytics & Performance
                  </span>
                </div>

                <Toggle
                  enabled={toggleStates.analyticsCookies}
                  toggle={() => toggleSwitch("analyticsCookies")}
                />
              </label>

              <label className="px-4 py-2 relative flex justify-between items-center border border-[#D7D7D7] rounded-[6px]">
                <div className="flex gap-2 items-center ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                  >
                    <path
                      d="M14.623 5.63178C14.7822 5.47714 14.9753 5.16679 14.9753 5.16679C14.9976 5.1374 15.0052 5.10004 14.9965 5.0646L14.9529 4.89157C14.9447 4.85915 14.9235 4.83141 14.8938 4.81466C14.8641 4.79763 14.8288 4.79324 14.7957 4.80231L13.422 5.17392C13.3711 5.18765 13.3165 5.16925 13.2854 5.1275L12.6544 4.28293C12.6352 4.25739 12.627 4.22525 12.6312 4.19393L12.7585 3.29662C12.7652 3.248 12.8011 3.20791 12.8501 3.19472L14.301 2.8025C14.3669 2.78465 14.4062 2.71929 14.39 2.65446L14.3329 2.4276C14.3247 2.39573 14.3041 2.36827 14.275 2.35124C14.275 2.35124 14.1613 2.27819 14.0785 2.23644C13.2544 1.82307 12.2168 1.95162 11.5258 2.62287C11.0152 3.11891 10.8153 3.79812 10.9089 4.44303C10.981 4.93878 10.9474 5.20245 10.7271 5.42877C10.5069 5.65509 6.09106 9.80876 6.09106 9.80876C6.03367 9.86178 6.00088 9.93511 6.00003 10.012C5.99889 10.0889 6.02999 10.1631 6.08627 10.2175L6.80551 10.9162C6.86176 10.9708 6.93783 11.0011 7.01699 11C7.09615 10.9991 7.17164 10.9673 7.22649 10.9118L11.8068 6.35524C11.8068 6.35524 12.1583 6.06218 12.5595 6.19512C13.2572 6.42664 14.0635 6.17561 14.623 5.63178Z"
                      fill="#666666"
                    />
                    <path
                      d="M9.47031 2.62575C9.49504 2.29064 9.24309 1.99615 8.9071 2.00061C7.66033 2.01715 6.43654 2.36662 5.36471 3.01797C4.11901 3.77499 3.14071 4.902 2.56634 6.24175C1.99196 7.58149 1.85015 9.06713 2.16071 10.4913C2.47127 11.9156 3.21869 13.2073 4.29868 14.1863C5.37868 15.1653 6.73736 15.7827 8.18512 15.9524C9.63289 16.1221 11.0975 15.8356 12.3746 15.1329C13.6517 14.4301 14.6776 13.3462 15.3091 12.0324C15.8524 10.902 16.0804 9.64988 15.9749 8.40748C15.9464 8.07266 15.6287 7.85075 15.2976 7.90815C14.9665 7.96555 14.7481 8.28066 14.7704 8.61594C14.8364 9.60763 14.6459 10.6033 14.2123 11.5053C13.6906 12.5907 12.8431 13.4862 11.788 14.0668C10.7329 14.6473 9.52288 14.884 8.32678 14.7438C7.13068 14.6037 6.00819 14.0936 5.11593 13.2847C4.22368 12.4759 3.60618 11.4087 3.34961 10.2321C3.09304 9.05546 3.21019 7.82808 3.68473 6.72122C4.15926 5.61437 4.96749 4.68327 5.99664 4.05785C6.85184 3.53815 7.82412 3.25107 8.81751 3.21971C9.15337 3.20911 9.44559 2.96086 9.47031 2.62575Z"
                      fill="#666666"
                    />
                  </svg>
                  <span class="text-sm text-[#131313]  font-semibold font-primary">
                    Functional & Preferences
                  </span>
                </div>
                <Toggle
                  enabled={toggleStates.functionalCookies}
                  toggle={() => toggleSwitch("functionalCookies")}
                />
              </label>

              <label class="px-4 py-2 relative flex justify-between items-center border border-[#D7D7D7] rounded-[6px]">
                <div className="flex gap-2 items-center ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                  >
                    <path
                      d="M16.3 8.52776L16.3 8.52957C16.3029 9.66593 16.0375 10.7868 15.5252 11.801L15.5238 11.8037C14.9155 13.0208 13.9805 14.0444 12.8233 14.7601L12.8232 14.7601C11.666 15.4757 10.3325 15.855 8.97194 15.8555L8.97035 15.8555C7.83407 15.8585 6.71319 15.593 5.69893 15.0807L5.43863 14.9492L5.16197 15.0415L1.1068 16.3932L2.45852 12.338L2.55074 12.0613L2.41926 11.801C1.90696 10.7868 1.64148 9.66591 1.64444 8.52959L1.64444 8.52803C1.64497 7.16748 2.02429 5.8339 2.73992 4.67672C3.45555 3.51953 4.47921 2.58444 5.69627 1.97618L5.69627 1.97618L5.69892 1.97484C6.71318 1.46254 7.83406 1.19706 8.97038 1.20003H8.97221H9.42469C11.2142 1.30338 12.9036 2.06079 14.1714 3.32859C15.4392 4.59639 16.1966 6.28578 16.3 8.07526L16.3 8.52776Z"
                      stroke="#666666"
                      stroke-width="1.4"
                    />
                  </svg>
                  <span class="text-sm text-[#131313]  font-semibold font-primary">
                    Advertising
                  </span>
                </div>

                <Toggle
                  enabled={toggleStates.advertisingCookies}
                  toggle={() => toggleSwitch("advertisingCookies")}
                />
              </label>
            </div>
            <p className="pt-5  text-sm font-opensans ">
              For in-depth details on each cookie, their providers, and more,
              refer to our{" "}
              <Link
                to="/legal/cookie-policy"
                className="text-[#3A7AFF] underline underline-offset-2"
              >
                Cookie Policy
              </Link>{" "}
              , you can also manage your cookie preferences on this page.
            </p>
          </div>
          <div className="border-t border-[#C6C6C6] w-full flex items-center md:justify-end md:flex-row flex-col-reverse gap-2 mt-3 py-4">
            <button
              onClick={acceptAllCookie}
              className="border  text-opensans font-semibold  border-[#FF7B16] bg-[#fff] text-[#FF7B16] lg:text-base text-sm md:w-[120px] w-full lg:py-[10px] py-2 rounded-[6px]"
            >
              Accept All
            </button>
            <button
              onClick={() => {
                localStorage.setItem("cookiePopup", "true");
                setCookiePreference(false);
                setShowCookie(false);
              }}
              className="border lg:text-base text-sm  lg:py-[10px] py-2 md:w-[120px]  rounded-[6px] bg-[#FF7B16] text-[#FFF] w-full"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManageCookie;
